

const FilterIcon = ({ size = 16, fill = "#3C2212" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 10.5C11.1529 10.5 11.707 10.9177 11.9131 11.5H13.5C13.7761 11.5 14 11.7239 14 12C14 12.2761 13.7761 12.5 13.5 12.5H11.9131C11.707 13.0823 11.1529 13.5 10.5 13.5C9.67157 13.5 9 12.8284 9 12C9 11.1716 9.67157 10.5 10.5 10.5ZM7.5 11.5C7.77614 11.5 8 11.7239 8 12C8 12.2761 7.77614 12.5 7.5 12.5H2.5C2.22386 12.5 2 12.2761 2 12C2 11.7239 2.22386 11.5 2.5 11.5H7.5ZM5.5 6.5C6.32843 6.5 7 7.17157 7 8C7 8.82843 6.32843 9.5 5.5 9.5C4.84707 9.5 4.29297 9.08234 4.08691 8.5H2.5C2.22386 8.5 2 8.27614 2 8C2 7.72386 2.22386 7.5 2.5 7.5H4.08691C4.29297 6.91766 4.84707 6.5 5.5 6.5ZM13.5 7.5C13.7761 7.5 14 7.72386 14 8C14 8.27614 13.7761 8.5 13.5 8.5H8.5C8.22386 8.5 8 8.27614 8 8C8 7.72386 8.22386 7.5 8.5 7.5H13.5ZM12.5 2.5C13.3284 2.5 14 3.17157 14 4C14 4.82843 13.3284 5.5 12.5 5.5C11.6716 5.5 11 4.82843 11 4C11 3.17157 11.6716 2.5 12.5 2.5ZM9.5 3.5C9.77614 3.5 10 3.72386 10 4C10 4.27614 9.77614 4.5 9.5 4.5H2.5C2.22386 4.5 2 4.27614 2 4C2 3.72386 2.22386 3.5 2.5 3.5H9.5Z"
      fill={fill}
    />
  </svg>
);

export default FilterIcon;
